"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormReducer = void 0;
var getCheckboxValue_1 = require("./dependencies/getCheckboxValue");
var deepCopyBackward_1 = require("./dependencies/deepCopyBackward");
var useFormReducer = function (initialForm) { return function (state, action) {
    if (action.actionType === "reset") {
        return (__assign({}, (initialForm || {})));
    }
    if (action.actionType === "set") {
        return action.value;
    }
    var path = action.key.split('.');
    if (action.actionType === "updateCheckbox") {
        action.value = !getCheckboxValue_1.getCheckboxValue(state, path);
    }
    var updatedState = deepCopyBackward_1.deepCopyBackward(state, path, action.value);
    return (__assign(__assign({}, state), updatedState));
}; };
exports.useFormReducer = useFormReducer;
//# sourceMappingURL=useFormReducer.js.map